import theme from '@/components/core/theme';
import { css } from '@linaria/core';

const breakpoint = '400px';

export const header = css`
  display: flex;
  grid-area: header;
  min-width: 0;
  margin-right: 2em;
  flex-direction: column;
  gap: 0.25em;
  position: relative;
  z-index: 20;
  font-size: 14px;
  @container feed (width > ${breakpoint}) {
    font-size: 17px;
  }
  a:hover {
    color: ${theme.colors.peoople['gris-claro']};
    text-decoration: underline;
  }
`;

export const headerRow = css`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.25rem;
  font-size: 1em;
  @container feed (width > ${breakpoint}) {
    column-gap: 0.5rem;
  }
`;

export const title = css`
  line-height: 1em;
  font-size: 18px;
  font-weight: 700;
  @container feed (width > ${breakpoint}) {
    font-weight: 800;
    font-size: 24px;
  }
`;

export const category = css`
  font-weight: 700;
  font-size: 1em;
`;

export const username = css`
  font-weight: 800;
`;

export const follow = css`
  font-weight: 700;
  font-size: 1em;
  display: none;
  @container feed (width > ${breakpoint}) {
    display: initial;
  }
`;

export const collection = css`
  display: flex;
  gap: 0.25em;
`;
